import { useEffect, useRef } from "react";
import AnimeCard from "@/components/base/AnimeCard";
import { animeList, categories } from "@/mocks/anime";

export default function SearchResults({ q }: { q: string }) {
  const ref = useRef<HTMLElement>(null);
  const term = q.trim().toLowerCase();

  useEffect(() => {
    if (ref.current) {
      const y = ref.current.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [q]);

  const results = animeList.filter((a) => {
    const cat = categories.find((c) => c.type === a.category);
    return (
      a.title.toLowerCase().includes(term) ||
      a.tags.some((t) => t.toLowerCase().includes(term)) ||
      (cat && (cat.name.includes(term) || cat.tagline.toLowerCase().includes(term)))
    );
  });

  return (
    <section ref={ref} className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <p className="text-sm text-primary-600 font-medium inline-flex items-center gap-2">
            <i className="ri-search-line"></i>
            搜索结果
          </p>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950">
            “{q}” 的搜索结果
          </h2>
          <p className="mt-2 text-sm text-foreground-500">共找到 {results.length} 部相关番剧</p>
        </div>

        {results.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {results.map((anime) => (
              <AnimeCard key={anime.id} anime={anime} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16 bg-background-50 rounded-2xl border border-background-200">
            <span className="mx-auto w-16 h-16 rounded-2xl bg-background-100 text-foreground-300 flex items-center justify-center text-3xl">
              <i className="ri-emotion-sad-line"></i>
            </span>
            <h3 className="mt-4 font-medium text-foreground-900">没有找到相关番剧</h3>
            <p className="mt-2 text-sm text-foreground-500">
              换个关键词试试，或者直接到下方题材分类中浏览
            </p>
          </div>
        )}
      </div>
    </section>
  );
}